import "./IntroSectionContainer.css";

export const IntroSectionContainer: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    return (
        <div className="intro-section">
            <div>{children}</div>
        </div>
    );
};
